import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import SegmentNameInput from "./segment-input-types/segment-name-input";
import SegmentOperatorInput from "./segment-input-types/segment-operator-input";
import SegmentValueInput from "./segment-input-types/segment-value-input";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentsCondition",
  components: {
    SegmentNameInput,
    SegmentOperatorInput,
    SegmentValueInput,
    InlinePrompt
  },
  props: {
    segments: {
      type: Array,
      required: true
    },
    condition: {
      type: Object,
      required: true
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    $v: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    var _context;
    return {
      nameValue: this.condition.id,
      operatorValue: this.condition.operator,
      values: _valuesInstanceProperty(this.condition),
      segmentOptions: _findInstanceProperty(_context = this.segments).call(_context, x => x.id == this.condition.id),
      inputType: ""
    };
  },
  computed: {
    multiOptionData() {
      var _this$segmentOptions$;
      return (_this$segmentOptions$ = _valuesInstanceProperty(this.segmentOptions.definitions[this.operatorValue])) == null ? void 0 : _reduceInstanceProperty(_this$segmentOptions$).call(_this$segmentOptions$, (acc, current) => {
        acc.push(_objectSpread(_objectSpread({}, current), {}, {
          label: current.value === "capped-variable" || current.value === "buy-down" ? current.label : current.value
        }));
        return acc;
      }, []);
    },
    nameValueString() {
      return this.nameValue.toString();
    },
    operator() {
      return this.condition.operator;
    }
  },
  watch: {
    condition: {
      handler(val) {
        var _context2;
        this.segmentOptions = _findInstanceProperty(_context2 = this.segments).call(_context2, elem => elem.id == val.id);
        this.nameValue = val.id;
        this.operatorValue = val.operator;
        this.$set(this, "values", _valuesInstanceProperty(val));
        this.inputType = this.segmentOptions.definitions[this.operatorValue].type;
      },
      immediate: true
    }
  },
  mounted() {
    this.inputType = this.segmentOptions.definitions[this.operatorValue].type;
  },
  methods: {
    emptyValue(id = "1") {
      return {
        id,
        value: ""
      };
    },
    handleNameChange(data) {
      var _context3;
      this.segmentOptions = _findInstanceProperty(_context3 = this.segments).call(_context3, x => x.id == data.id);
      const newOperator = this.segmentOptions.operators[0];
      const newType = this.segmentOptions.definitions[newOperator].type;
      const name = {
        id: _parseInt(data.id, 10),
        operator: newOperator
      };
      const newValue = {
        "single-value": [this.emptyValue("1")],
        "multi-value": [this.emptyValue("1"), this.emptyValue("2")],
        "multi-option": []
      };
      name.values = newValue[newType];
      this.$emit("change", name);
    },
    handleOperatorChange(data) {
      const operator = {
        operator: data.id
      };
      if (this.inputType === "multi-value" && data.id !== "range") {
        operator.values = [this.emptyValue("1")];
      } else if (this.inputType !== "multi-value" && data.id === "range") {
        operator.values = [this.emptyValue("1"), this.emptyValue("2")];
      }
      this.$emit("change", operator);
    },
    handleValueChange({
      data,
      type
    }) {
      switch (this.inputType) {
        case "single-value":
          this.values = [data];
          break;
        case "multi-value":
          _valuesInstanceProperty(this)[data.id - 1] = data;
          break;
        case "multi-option":
          if (type === "select") {
            _valuesInstanceProperty(this).push(data);
          } else if (type === "unselect") {
            var _context4;
            this.values = _filterInstanceProperty(_context4 = _valuesInstanceProperty(this)).call(_context4, elem => elem.id !== data.id);
          }
      }
      const values = {
        values: _valuesInstanceProperty(this)
      };
      this.$emit("change", values);
    },
    handleDelete() {
      this.$emit("delete");
    }
  }
});